import { Component, computed, input } from "@angular/core";

@Component({
  selector: "oct-svg",
  styleUrls: ["./oct-svg.component.scss"],
  host: {
    "[style.-webkit-mask-image]": "maskImage()",
    "[style.mask-image]": "maskImage()",
  },
  template: ``,
})
export class OctSvgComponent {
  path = input.required<string>();
  maskImage = computed(() => `url("${this.path()}")`);
}
